import { reactive } from 'vue'
import catalogosViewService from './catalogosView.service'

const TITULO_KEY     = 'g3_titulo_principal'
const TITULO_DEFAULT = 'Panel principal'
const CLAVE_PARAM    = 'G_TITULO'

const state = reactive({
  titulo: localStorage.getItem(TITULO_KEY) || TITULO_DEFAULT
})

export default {
  state,

  /**
   * Título actual (cacheado en localStorage o el default mientras carga).
   */
  getTitulo() {
    return state.titulo || TITULO_DEFAULT
  },

  /**
   * Relee el parámetro g_titulo del catálogo v_cat_parametro y actualiza
   * el título cacheado. Se debe llamar al cargar la app y al iniciar sesión,
   * por si alguien cambió el valor desde otra sesión.
   */
  async refrescar() {
    try {
      const cats  = await catalogosViewService.leerVarios('parametro')
      const items = Array.isArray(cats?.parametro) ? cats.parametro : []
      const candidatos = items.filter(x => String(x.Clave || '').toUpperCase() === CLAVE_PARAM)
      const item  = candidatos.find(x => Number(x.EmpresaId || 0) === 0) || candidatos[0] || null
      const valor = String(item?.Valor || item?.Nombre || '').trim()
      if (valor) {
        state.titulo = valor
        localStorage.setItem(TITULO_KEY, valor)
      }
    } catch (_) {
      // si falla, se conserva el valor cacheado / default
    }
  }
}
